export default __webpack_public_path__ + "static/media/group-avarts.893656a0.png";